import React, { useEffect, useState } from "react";
import BackButton from "../../../components/fulfillment/_common/BackButton";
import { useShopifyStoreIndex, useShopifySyncOrder } from "../../../hooks/integrations/shopify";
import StoreSelectTable from "./StoreSelectTable";
import SyncOrderView from "./SyncOrderView";
import { notification, Button } from "antd";
import { useHistory, useParams } from "react-router";
import { get } from "lodash-es";

const SyncOrderWithShopifyPage = () => {
  const [isOrderSyncView, setIsOrderSyncView] = useState(false);
  const [selectedShop, setSelectedShop] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const { storeIndex, fetchStores } = useShopifyStoreIndex();
  const { syncOrderDetails, syncOrder } = useShopifySyncOrder();
  const history = useHistory();
  const params = useParams();
  const organizationID = get(params, "organization_id");
  const query = {
    per_page: 5,
    organization_id: organizationID,
  };
  const filteredStores = storeIndex.data?.filter((store) => !store.fulfillment_service_mode_enabled);

  // eslint-disable-next-line
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    fetchStores(query);
  }, []);

  useEffect(() => {
    const error = storeIndex.error || syncOrderDetails.error;
    if (error) {
      notification.error({
        message: "Error",
        description: error,
      });
    }
  }, [storeIndex.error, syncOrderDetails.error]);

  const renderHeader = () => {
    const onClick = isOrderSyncView
      ? () => setIsOrderSyncView(false)
      : () => history.push(`/organizations/${organizationID}/orders`);

    return (
      <div className="header">
        <div className="back-button-wrapper">
          <BackButton onClick={onClick}>Back</BackButton>
        </div>
        <div className="title">{isOrderSyncView ? "Shopify Order Sync" : "Select Shopify Stores"}</div>
        <div className="dummy" />
      </div>
    );
  };

  const handleShopifyOrderSync = (shopifyOrderID) => {
    syncOrder(selectedShop.name, shopifyOrderID, organizationID);
  };

  const renderContent = () => {
    if (!isOrderSyncView) {
      return (
        <StoreSelectTable
          onSelectShop={(s) => setSelectedShop(s)}
          shops={filteredStores}
          selectedShop={selectedShop}
          loading={storeIndex.loading}
        />
      );
    } else {
      return (
        <SyncOrderView
          loading={syncOrderDetails.loading || false}
          foundOrder={syncOrderDetails.data}
          selectedOrder={selectedOrder}
          onSelectOrder={(order) => setSelectedOrder(order)}
          onSyncOrder={(shopifyOrderID) => handleShopifyOrderSync(shopifyOrderID)}
        />
      );
    }
  };

  const renderContinueButton = () => {
    return (
      <div className="continue-button-row">
        <Button disabled={!selectedShop} onClick={() => setIsOrderSyncView(true)}>
          Continue
        </Button>
      </div>
    );
  };

  const renderCreateShipmentButton = () => {
    const orderID = get(selectedOrder, "id");
    const path = `fulfillment/orders/${orderID}/create-shipment?isReturn=true`;
    return (
      <div className="continue-button-row">
        <Button disabled={!orderID} onClick={() => history.push(path)}>
          Create Shipment
        </Button>
      </div>
    );
  };

  return (
    <div className="page-container no-sub-nav-bar" id="sync-order-with-shopify-page">
      {renderHeader()}
      {renderContent()}
      {isOrderSyncView ? renderCreateShipmentButton() : renderContinueButton()}
    </div>
  );
};

export default SyncOrderWithShopifyPage;
